import { ConfigSection } from "../../components-fabric";
import HomeScreen from "./views/HomeScreen";
import { publicLayout } from "../_common/layout.public";

/**
 * Configuration Section: homeSection
 *
 * This configuration section defines the public home screen for the application. It uses a public layout and is not protected,
 * meaning it can be accessed without authentication.
 *
 * Properties:
 * @property {string} id - The unique identifier for this section, set to 'public'.
 * @property {Object} layout - The layout component to use for this section, which is a public layout.
 * @property {boolean} protected - Indicates if the section requires authentication to access (false for this section).
 * @property {string} tmp - The template type to use for this section, set to 'basic'.
 * @property {string} path - The base path for this section's routes, which is the root path ("/").
 * @property {Array} screens - An array of screen configurations included in this section.
 */
export const homeSection: ConfigSection= {
  id: 'public',
  layout: publicLayout,
  protected: false,
  tmp: 'basic',
  path:"/",
  screens:[
  {
    id: 'home',
    path:".",
    Component: HomeScreen
  }
]};
